import { useState } from "react";
import { FiPlus, FiMinus, FiChevronRight, FiHome } from "react-icons/fi";
import { useParams, Link } from "react-router-dom";
import Service from "../../../Data/demo";
import { motion, AnimatePresence } from "framer-motion";
import { Helmet } from "react-helmet";
import { FaArrowRight, FaCheck, FaLightbulb, FaRocket, FaShieldAlt, FaUsers, FaChartLine } from "react-icons/fa";
import React from "react";

export default function SubServiceDetail() {
  const { serviceSlug, subSlug } = useParams();
  const service = Service.find((s) => s.slug === serviceSlug);
  const subService = service?.subServices?.find((sub) => sub.slug === subSlug);

  const handleScroll = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };


  // Add this state at the top of your SubServiceDetail component
  const [openIndex, setOpenIndex] = useState(-1); // First item open by default

  // Add this function to handle toggle
  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };


  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        when: "beforeChildren",
        staggerChildren: 0.15,
        ease: "easeOut"
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 15,
        duration: 0.6
      }
    }
  };

  // const fadeIn = {
  //   hidden: { opacity: 0 },
  //   show: {
  //     opacity: 1,
  //     transition: { duration: 0.8 }
  //   }
  // };

  if (!service || !subService) return <p className="p-8 text-xl text-center">Sub-Service not found</p>;


  // Add this FAQItem component before your return statement
  const FAQItem = ({ faq, index, isOpen, onToggle }) => {
    return (
      <div>

        <motion.div
          variants={itemVariants}
          className="group"
        >

          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 transition-all duration-300 overflow-hidden my-4">
            <button
              onClick={onToggle}
              className="w-full p-6 text-left flex items-center justify-between gap-4 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-gray-800 rounded-2xl"
            >
              <div className="flex items-start gap-4 flex-1">
                <div className="flex-1">
                  <h3 className={`text-lg font-semibold transition-colors duration-300 text-left ${isOpen
                      ? 'text-blue-500 dark:text-blue-400'
                      : 'text-gray-900 dark:text-white'
                    }`}>
                    {faq.question}
                  </h3>
                </div>
              </div>

              <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 ${isOpen
                  ? 'bg-blue-500 text-white'
                  : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400'
                }`}>
                {isOpen ? (
                  <FiMinus className="w-4 h-4" />
                ) : (
                  <FiPlus className="w-4 h-4" />
                )}
              </div>
            </button>

            <AnimatePresence>
              {isOpen && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: 'auto', opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3, ease: 'easeInOut' }}
                  className="overflow-hidden"
                >
                  <div className="px-6 pb-6">
                    <div className="pl-4 border-l-2 border-blue-200 dark:border-blue-800">
                      <motion.p
                        initial={{ y: -10, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.1, duration: 0.3 }}
                        className="text-gray-600 dark:text-gray-300 leading-relaxed text-left"
                      >
                        {faq.answer}
                      </motion.p>
                    </div>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </motion.div>
      </div>
    );
  };

      const Breadcrumb = () => {
      return (
        <nav className="mb-8" aria-label="Breadcrumb">
          <ol className="hidden  items-center space-x-2 text-sm text-gray-600 dark:text-gray-400">
            <li className="flex items-center">
              <Link to="/" onClick={handleScroll} className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors flex items-center">
                <FiHome className="w-4 h-4 mr-1" />
                Home
              </Link>
            </li>
            <li className="flex items-center">
              <FiChevronRight className="w-4 h-4 mx-1" />
              <Link to="/services" onClick={handleScroll} className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors flex items-center" aria-current="page">Services</Link>
            </li>
            <li className="flex items-center">
              <FiChevronRight className="w-4 h-4 mx-1" />
              <Link to ={`/services/${service.title}`} onClick={handleScroll} className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors flex items-center" aria-current="page">{service.title}</Link>
            </li>
            <li className="flex items-center">
              <FiChevronRight className="w-4 h-4 mx-1" />
              <span className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors flex items-center" aria-current="page">{subService.title}</span>
            </li> 
          </ol>
          
          {/* Structured data for Google (invisible to users but helps SEO) */}
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [{
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": window.location.origin
              }, {
                "@type": "ListItem",
                "position": 2,
                "name": "Services",
                "item": window.location.href
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": service.title,
                "item": window.location.href
              },
              {
                "@type": "ListItem",
                "position": 4,
                "name": subService.title,
                "item": window.location.href
              }
            ]
            })}
          </script>
        </nav>
      );
    };

  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>{subService.seo?.metaTitle || `${subService.title} | ${service.title}`}</title>
        <meta name="description" content={subService.seo?.metaDescription || subService.description} />
        {subService.seo?.keywords && (
          <meta name="keywords" content={Array.isArray(subService.seo.keywords) ? subService.seo.keywords.join(', ') : subService.seo.keywords} />
        )}
        <link rel="canonical" href={`https://merndigital.com/services/${service.slug}/${subService.slug}`} />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white dark:from-gray-900 dark:to-gray-800">
        {/* Breadcrumb Navigation */}
        {/* <motion.nav
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="pt-8 pb-6 px-6 max-w-7xl mx-auto"
        >
          <ol className="flex items-center space-x-2 text-sm text-gray-600 dark:text-gray-400">
            <li>
              <Link to="/" className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-300">
                Home
              </Link>
            </li>
            <li><FaChevronRight className="w-3 h-3 mx-2" /></li>
            <li>
              <Link to="/services" className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-300">
                Services
              </Link>
            </li>
            <li><FaChevronRight className="w-3 h-3 mx-2" /></li>
            <li>
              <Link to={`/services/${service.slug}`} className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-300">
                {service.title}
              </Link>
            </li>
            <li><FaChevronRight className="w-3 h-3 mx-2" /></li>
            <li className="text-blue-600 dark:text-blue-400 font-medium truncate">{subService.title}</li>
          </ol>
        </motion.nav> */}
        <Breadcrumb />

        <div className="max-w-7xl mx-auto px-6 pb-20">
          {/* Hero Section */}
          <motion.section
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="py-16 mb-16 text-center"
          >
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300 text-sm font-medium mb-6">
              {service.title} Service
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 dark:text-white mb-6 leading-tight">
              {subService.title}
            </h1>

            <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto mb-8 leading-relaxed">
              {subService.description}
            </p>

            <div className="max-w-2xl mx-auto bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 p-6 rounded-2xl border border-blue-100 dark:border-blue-800/30">
              <p className="text-lg text-blue-700 dark:text-blue-300 font-medium">
                {subService.briefDescription}
              </p>
            </div>
          </motion.section>

          {/* Process Steps */}
          <motion.section
            variants={containerVariants}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-100px" }}
            className="mb-20"
          >
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
                Our Process
              </h2>
              <p className="text-lg text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
                A structured approach to deliver exceptional results
              </p>
            </div>

            <div className="relative">
              {/* Timeline connector */}
              <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-gradient-to-b from-blue-500 to-purple-500 hidden md:block"></div>

              <div className="grid md:grid-cols-1 gap-8">
                {subService.processSteps.map((step, i) => (
                  <motion.div
                    key={i}
                    variants={itemVariants}
                    className={`flex flex-col md:flex-row items-center ${i % 2 === 0 ? 'md:flex-row-reverse' : ''}`}
                  >
                    <div className="md:w-1/2 mb-6 md:mb-0 md:px-8">
                      <div className="bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-lg border border-gray-100 dark:border-gray-700">
                        <div className="w-14 h-14 bg-gradient-to-r from-blue-500 to-purple-500 rounded-xl flex items-center justify-center text-white font-bold text-xl mb-4 shadow-lg">
                          {i + 1}
                        </div>
                        <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">Step {i + 1}</h3>
                        <p className="text-gray-600 dark:text-gray-300 leading-relaxed">{step}</p>
                      </div>
                    </div>

                    <div className="md:w-1/2 md:px-8">
                      {/* Empty space for alignment */}
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.section>

          {/* Why Choose Us */}
          <motion.section
            variants={containerVariants}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-100px" }}
            className="mb-20"
          >
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
                Why Choose Us?
              </h2>
              <p className="text-lg text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
                Discover what sets our services apart from the competition
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {subService.whyUs.map((reason, i) => (
                <motion.div
                  key={i}
                  variants={itemVariants}
                  className="bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 hover:shadow-md transition-all duration-300 group"
                >
                  <div className="w-12 h-12 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center text-blue-600 dark:text-blue-400 mb-6 group-hover:scale-110 transition-transform duration-300">
                    {i % 5 === 0 ? <FaRocket className="w-6 h-6" /> :
                      i % 5 === 1 ? <FaLightbulb className="w-6 h-6" /> :
                        i % 5 === 2 ? <FaShieldAlt className="w-6 h-6" /> :
                          i % 5 === 3 ? <FaUsers className="w-6 h-6" /> :
                            <FaChartLine className="w-6 h-6" />}
                  </div>
                  <p className="text-lg font-medium text-gray-800 dark:text-gray-200 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors duration-300">{reason}</p>
                </motion.div>
              ))}
            </div>
          </motion.section>

          {/* Tech Stack */}
          {subService.techStack && (
            <motion.section
              variants={containerVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-100px" }}
              className="mb-20"
            >
              <div className="text-center mb-12">
                <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
                  Technology Stack
                </h2>
                <p className="text-lg text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
                  We leverage cutting-edge technologies to deliver superior solutions
                </p>
              </div>

              <div className="grid lg:grid-cols-2 gap-8">
                {typeof subService.techStack === 'string' ? (
                  <div className="bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700">
                    <p className="text-gray-600 dark:text-gray-300 text-lg">{subService.techStack}</p>
                  </div>
                ) : Array.isArray(subService.techStack) ? (
                  <div className="bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700">
                    <div className="flex flex-wrap gap-3">
                      {subService.techStack.map((tech, i) => (
                        <motion.span
                          key={i}
                          initial={{ opacity: 0, scale: 0.8 }}
                          whileInView={{ opacity: 1, scale: 1 }}
                          transition={{ delay: i * 0.05 }}
                          viewport={{ once: true }}
                          className="px-4 py-2 rounded-lg text-sm font-medium bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 border border-blue-100 dark:border-blue-800/50 hover:bg-blue-100 dark:hover:bg-blue-900/50 transition-colors duration-300"
                        >
                          {tech}
                        </motion.span>
                      ))}
                    </div>
                  </div>
                ) : (
                  Object.entries(subService.techStack).map(([category, technologies]) => (
                    <motion.div
                      key={category}
                      variants={itemVariants}
                      className="bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700"
                    >
                      <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-6 capitalize border-b border-gray-200 dark:border-gray-700 pb-3">
                        {category.replace(/([A-Z])/g, ' $1')}
                      </h3>

                      <div className="flex flex-wrap gap-3">
                        {typeof technologies === 'string' ? (
                          technologies.split(', ').map((tech, i) => (
                            <span
                              key={i}
                              className="px-4 py-2 rounded-lg text-sm font-medium bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-600"
                            >
                              {tech}
                            </span>
                          ))
                        ) : Array.isArray(technologies) ? (
                          technologies.map((tech, i) => (
                            <span
                              key={i}
                              className="px-4 py-2 rounded-lg text-sm font-medium bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-600"
                            >
                              {tech}
                            </span>
                          ))
                        ) : (
                          <p className="text-gray-600 dark:text-gray-400">{technologies}</p>
                        )}
                      </div>
                    </motion.div>
                  ))
                )}
              </div>
            </motion.section>
          )}

          {/* Impact Section */}
          {subService.impact && subService.impact.length > 0 && (
            <motion.section
              variants={containerVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-100px" }}
              className="mb-20"
            >
              <div className="text-center mb-12">
                <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
                  Impact & Benefits
                </h2>
                <p className="text-lg text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
                  How our service delivers tangible value to your business
                </p>
              </div>

              <div className="grid md:grid-cols-2 gap-8">
                {subService.impact.map((impact, i) => (
                  <motion.div
                    key={i}
                    variants={itemVariants}
                    className="bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 hover:shadow-md transition-all duration-300"
                  >
                    <div className="flex items-start">
                      <div className="w-8 h-8 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center text-green-600 dark:text-green-400 mr-4 mt-1 flex-shrink-0">
                        <FaCheck className="w-4 h-4" />
                      </div>
                      <p className="text-lg font-medium text-gray-800 dark:text-gray-200">{impact}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.section>
          )}

          {/* FAQ Section */}
          <div className="">
            <h2 className="text-2xl font-bold text-white text-center">Frequently Asked Questions</h2>
            {subService.faq.map((faq, i) => (
              <FAQItem
                key={i}
                faq={faq}
                index={i}
                isOpen={openIndex === i}
                onToggle={() => handleToggle(i)}
              />
            ))}
          </div>

          {/* CTA Section */}
          {subService.cta && (
            <motion.section
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              viewport={{ once: true, margin: "-100px" }}
              className="text-center"
            >
              <div className="bg-gradient-to-r from-blue-600 to-purple-600 p-12 rounded-3xl shadow-xl">
                <h2 className="text-3xl font-bold text-white mb-6">
                  Ready to Get Started?
                </h2>
                <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
                  Let's discuss how our {subService.title} services can help your business.
                </p>
                <Link onClick={handleScroll}
                  to={subService.cta.link || "/contact"}
                  className="inline-flex items-center px-8 py-4 bg-white text-blue-600 rounded-xl font-bold hover:bg-gray-100 transition-all duration-300 transform hover:-translate-y-1 shadow-lg"
                >
                  {subService.cta.text}
                  <FaArrowRight className="w-5 h-5 ml-3" />
                </Link>

                <p className="text-blue-200 mt-6">
                  No obligation, free consultation
                </p>
              </div>
            </motion.section>
          )}
        </div>
      </div>
    </>
  );
}